export default {
  velt: {
    openPanel: '打开评论面板',
    closePanel: '关闭评论面板',
    panel: '评论面板',
    tabs: '评论面板标签',
    comments: '评论',
    settings: '设置与权限',
    dragOrTapComment: '拖动以添加评论，或点按以查看评论',
    assignComment: '分配评论',
    markAsUnread: '标记为未读',
    markAsRead: '标记为已读',
    unsubscribe: '取消订阅',
    subscribe: '订阅',
    deleteThread: '删除讨论串',
    editComment: '编辑评论',
    emptyPlaceholder: '提供反馈、提出问题，或为团队成员留下备注',
    searchPlaceholder: '搜索评论',
    commentPlaceholder: '评论 {page}',
    replyPlaceholder: '回复....',
    filterPages: '页面',
    filterAuthor: '作者',
    filterTagged: '已标记',
    statusOpen: '未解决',
    statusResolved: '已解决',
    anonymous: '匿名',
    settingsPanel: {
      title: '谁可以评论？',
      everyoneLabel: '所有人',
      restrictedLabel: '仅受邀协作者',
      emailsLabel: '电子邮件',
      emailsPlaceholder: '添加电子邮件并按 Enter',
    },
  },
}
